import { render, staticRenderFns } from "./TemplateDialogWraper.vue?vue&type=template&id=1063dfc9&"
import script from "./TemplateDialogWraper.vue?vue&type=script&lang=js&"
export * from "./TemplateDialogWraper.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDialogWraper.vue?vue&type=style&index=0&id=1063dfc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports